import { Controller } from "@hotwired/stimulus"

/**
 * Controller that injects current search params as hidden fields into a form
 * Used when creating a new saved view to capture the current filter state
 */
export default class extends Controller {
  static targets = ["container"]

  connect() {
    this.injectSearchParams()
  }

  injectSearchParams() {
    // Get params from the task-beta-saved-views controller
    const taskBetaController = this.application.getControllerForElementAndIdentifier(
      document.querySelector('[data-controller*="task-beta-saved-views"]'),
      'task-beta-saved-views'
    )

    if (!taskBetaController || !taskBetaController.getCurrentParams) {
      console.warn('Could not find task-beta-saved-views controller')
      return
    }

    const params = taskBetaController.getCurrentParams()

    // Create hidden fields for each param
    Object.entries(params).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach(v => {
          this.addHiddenField(`saved_form_view[search_params][${key}][]`, v)
        })
      } else {
        this.addHiddenField(`saved_form_view[search_params][${key}]`, value)
      }
    })
  }

  addHiddenField(name, value) {
    const input = document.createElement('input')
    input.type = 'hidden'
    input.name = name
    input.value = value
    this.containerTarget.appendChild(input)
  }
}
